import { render, staticRenderFns } from "./IndagineEpidemiologicaEpatiteAcutaViewComponent.vue?vue&type=template&id=7a031017"
import script from "./IndagineEpidemiologicaEpatiteAcutaViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEpatiteAcutaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports